// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2uVUvJZUoSv2xATW-3nw3y","title":"_33_tNm2fOkRodXFRdf47s5","loader":"_2OQ0E8J_iVUsw92W9y79_f"};